import enrollPatientIntoRegistryAction from '@app/s/registry/actions/enrollPatientIntoRegistryAction'
import Button, { buttonClassNames } from '@components/primitives/Button'
import { EllipsesPulse } from '@components/primitives/LoadingWrapper/EllipsesPulse'
import { classMerge } from '@components/utilities/classMerge'
import PatientRoutes from '@lib/routes/PatientRoutes'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import type { ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'
import { useRouter } from 'next/navigation'
import { useState } from 'react'
import { getApplySuccessRouteToRedirectTo } from '../ConsentToShareEmrStep/getApplySuccessRouteToRedirectTo'

export function PatientRegistryEnrollmentButtonGroup({
  consentForEmr,
  consentToShareYourStory,
  hasPatientNavigatorAgentCallCompleted,
  idToken,
  patientNavigatorAgentId,
  patientRegistryEnrolled,
  screeningVisitAvailabilities,
  whyAreYouApplying,
}: Pick<
  ApplySuccessPageProps,
  | 'consentForEmr'
  | 'consentToShareYourStory'
  | 'hasPatientNavigatorAgentCallCompleted'
  | 'idToken'
  | 'patientNavigatorAgentId'
  | 'patientRegistryEnrolled'
  | 'screeningVisitAvailabilities'
  | 'whyAreYouApplying'
>) {
  const [isLoading, setIsLoading] = useState(false)

  async function enrollPatientIntoRegistry() {
    setIsLoading(true)
    await enrollPatientIntoRegistryAction({
      trialApplicationIdToken: idToken,
    })
    trackEvent(TrackingEvents.PATIENT_REGISTRY_ENROLLMENT_YES_CLICKED, {
      source: TrackingSources.TRIAL_APPLICATION_FORM,
    })
    setIsLoading(false)
  }

  const router = useRouter()

  return (
    <div className='flex w-full flex-row gap-2'>
      <Button
        className={classMerge(
          buttonClassNames.legacy.outline.white,
          'pointer-events-auto w-full rounded-full',
        )}
        onClick={() => {
          trackEvent(TrackingEvents.PATIENT_REGISTRY_ENROLLMENT_NO_CLICKED, {
            source: TrackingSources.TRIAL_APPLICATION_FORM,
          })
          router.push(
            getApplySuccessRouteToRedirectTo('medical-release-consent', {
              consentForEmr,
              consentToShareYourStory,
              hasPatientNavigatorAgentCallCompleted,
              idToken,
              patientNavigatorAgentId,
              patientRegistryEnrolled,
              screeningVisitAvailabilities,
              whyAreYouApplying,
            }),
          )
        }}
        value='Decline'
      />
      <Button
        className={classMerge(
          buttonClassNames.legacy.fill.black,
          'pointer-events-auto w-full rounded-full',
        )}
        onClick={async () => {
          await enrollPatientIntoRegistry()
          router.push(
            PatientRoutes.trialApplySurveyPostscreenerConsents(
              idToken,
              'guardian', // if they agree, we have to ask to see if they have a guardian
            ),
          )
        }}
        value={
          isLoading ? <EllipsesPulse ellipsesColor={'bg-white'} /> : 'Accept'
        }
      />
    </div>
  )
}
